import { useState } from 'react'

import { ActivityProps } from '~/bootcamp/Activities/types/activities.types'
import ActivityWrapper from '~/bootcamp/Activities/components/ActivityWrapper'

import NumericButton from '~/bootcamp/Activities/Factorization/component/NumericButton'

import { useEmitInstance } from '~/bootcamp/Activities/utils/instance.utils'

import { usePrimeSelect } from './usePrimeSelect'

const PrimeSelect = ({
  answerState,
  onAnswerStateChange,
  onNextQuestionClick,
  onInstanceChange,
  actionButtonsFC: SubmitButton,
  difficultyLevel,
}: ActivityProps): React.ReactElement => {
  const [answer, setAnswer] = useState<number>(0)

  const [primeSelectQuestion, setPrimeSelectQuestion, verifyAnswer] = usePrimeSelect(difficultyLevel)

  useEmitInstance(onInstanceChange, primeSelectQuestion.length ? `options: ${primeSelectQuestion.join(', ')}` : null)

  const onSelect = (selectedValue: number): void => {
    setAnswer(selectedValue)

    // Reset answer state
    onAnswerStateChange(null)
  }

  const checkAnswer = (): void => {
    const isCorrect: boolean = verifyAnswer(answer)
    onAnswerStateChange(isCorrect)
  }

  const nextQuestion = (): void => {
    setPrimeSelectQuestion()
    clearAnswer()
    onNextQuestionClick()
  }

  const clearAnswer = (): void => {
    setAnswer(0)

    // Reset answer state
    onAnswerStateChange(null)
  }

  return (
    <ActivityWrapper className="justify-between">
      <div className="flex flex-1 justify-between items-center w-full md:px-7">
        {primeSelectQuestion.map((primeNumber) => (
          <NumericButton
            isSelected={answer === primeNumber}
            isWrong={answer === primeNumber && answerState === false}
            key={primeNumber}
            onClick={onSelect.bind(null, primeNumber)}
          >
            {primeNumber}
          </NumericButton>
        ))}
      </div>

      {SubmitButton && (
        <SubmitButton
          clearFormAction={clearAnswer}
          correctAnswer={!!answerState}
          formValid={answer !== 0}
          goToNextQuestionAction={nextQuestion}
          submitAnswerAction={checkAnswer}
        />
      )}
    </ActivityWrapper>
  )
}

export default PrimeSelect
